/*
 * Author: harper
 * File Created: Friday, 23-07-14 05:43 pm
 * Last Modified: Monday, 25-07-21 10:02 am, by Dw
 * Copyright © 2023 - Liberty MIT
 */

import * as React from 'react';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { isNativeApp, isOpenApi } from '@ucard/next-core/utils';
import { Box } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import { showDialog } from '@ucard/ds/message';
import Image from '@/components/Image';
import { useUserInfo } from '@/stores/useUserStore';
import { staticImgPrefix } from '@/utils/prefix';
import type { HeaderDialogProps } from './HeaderDialog';
import HeaderDialog from './HeaderDialog';
import { HeaderAvatar, StyledHeader, StyledLoginButton, StyledToolbar } from './style';
const Header = ({
  hideMenu = false
}: {
  hideMenu: boolean;
}) => {
  const router = useRouter();
  const [client, setClient] = useState<boolean>(false);
  useEffect(() => {
    setClient(true);
  }, [client]);
  const {
    t
  } = useTranslation('common');
  const {
    isLogin
  } = useUserInfo();
  const logoSrc = router.pathname === '/dvault' ? staticImgPrefix('/header/dvault.webp') : staticImgPrefix('/header/logo.webp');
  const handleClick = React.useCallback(() => {
    if (router.pathname === '/account') return;
    router.push('/account');
  }, [router]);
  const goUrl = React.useCallback((pathname: string) => {
    router.push(pathname);
  }, [router]);
  const showHeaderDialog = React.useCallback(() => {
    const close = showDialog<HeaderDialogProps>(HeaderDialog, {
      isLogin: Boolean(isLogin),
      onClose: () => {
        close();
      }
    });
  }, [isLogin]);
  const goHome = React.useCallback(() => {
    router.push('/dvault');
  }, [router]);
  const renderToolbar = React.useMemo(() => {
    // if ((isNativeApp() || !client) && isOpenApi) return null;
    if (isOpenApi) return null;
    return <StyledToolbar>
        <Box onClick={goHome} sx={{
        display: 'inline-block',
        width: '83px',
        height: '20px',
        cursor: 'pointer'
      }}>
          <Image alt="logo" height={20} priority src={logoSrc} width={83} />
        </Box>
        {hideMenu ? null : <Box alignItems="center" display="flex" gap={1}>
            {isLogin === false && <StyledLoginButton color="inherit" onClick={() => {
          goUrl(router.pathname === '/login' ? '/signup' : '/login');
        }} variant="outlined">
                {router.pathname === '/login' ? t('header.register') : t('header.login')}
              </StyledLoginButton>}

            {isLogin && <HeaderAvatar onClick={handleClick} src={staticImgPrefix('/account/avatar.webp')} />}
            <Icon htmlColor="#707A8A" name="HeaderMenuBtn" onClick={showHeaderDialog} sx={{
          fontSize: '24px',
          cursor: 'pointer'
        }} />
          </Box>}
      </StyledToolbar>;
  }, [goHome, goUrl, handleClick, hideMenu, isLogin, logoSrc, router.pathname, showHeaderDialog, t]);
  return <StyledHeader enableColorOnDark position="static" data-sentry-element="StyledHeader" data-sentry-component="Header" data-sentry-source-file="index.tsx">
      {renderToolbar}
    </StyledHeader>;
};
export default Header;